import React from 'react'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  RemoveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {useForm} from 'react-hook-form'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import Settings from 'Event/Sponsors/Buttons/SponsorButtonConfig/Settings'
import Styling from 'Event/Sponsors/Buttons/SponsorButtonConfig/Styling'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'
import {NavButtonProps} from 'Event/Dashboard/components/NavButton'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'

export default function SponsorButtonConfig(
  props: ComponentConfigProps & {
    button: NavButtonProps
    onChange: (button: NavButtonProps) => void
    onRemove: () => void
    id?: string
    sponsorId?: string
  },
) {
  const {
    showing: visible,
    onClose,
    button,
    onChange,
    onRemove,
    id,
    sponsorId,
  } = props

  const {
    control,
    handleSubmit,
    watch,
    register,
    setValue,
    formState,
  } = useForm()

  useAutoUpdate({
    values: {
      sponsors: {
        items: {
          [sponsorId!]: {
            buttons: {
              [id!]: watch(),
            },
          },
        },
      },
    },
    when: Boolean(visible),
  })

  const submit = (form: NavButtonProps) => {
    onChange(form)
    onClose()
  }

  // Fixes a bug where hook-form isDirty is returning true even when dirtyFields is empty
  const isDirty = Object.keys(formState.dirtyFields).length > 0

  return (
    <ComponentConfig
      showing={visible}
      onClose={onClose}
      title="Sponsor Button"
      onSubmit={handleSubmit(submit)}
      hasChanges={isDirty}
    >
      <SettingsPanel>
        <Settings
          control={control}
          register={register}
          watch={watch}
          button={button}
          setValue={setValue}
        />
      </SettingsPanel>
      <StylingPanel>
        <Styling
          control={control}
          watch={watch}
          setValue={setValue}
          button={button}
        />
      </StylingPanel>
      <RulesPanel control={control} name="rules" rules={button?.rules}>
        <ScheduleInput control={control} setValue={setValue} values={button} />
      </RulesPanel>
      <Footer>
        <SaveButton type="submit" />
        <RemoveButton
          aria-label="remove button"
          onClick={onRemove}
          showing={Boolean(props.id)}
        />
      </Footer>
    </ComponentConfig>
  )
}
